import React, { Component } from "react";
import { Table, Input, Button, Tooltip, Card, Select, Tag } from "antd";
import { connect } from "react-redux";
import { API_BASE } from "../../utils/contrains";
import { getDateYYYYMM, formateHHMMDate } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import { req_list_pim_staff, req_downloadfile_pim_staff } from "../../api";

class ClockLogStaff extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    searchField: "None",
    searchValue: "",
    data: [],
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 數據配置設定 //////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "日期",
        width: "50px",
        align: "center",
        fixed: "true",
        render: (item) => {
          const { ClockDate, WeekdayName, WorkStatus } = item;
          return (
            <>
              <span
                style={{
                  fontWeight: 900,
                  fontSize: "1.2em",
                  color: WorkStatus === "PASS" ? "#B22222" : "#483D8B",
                }}
              >
                {ClockDate}
                {WeekdayName}
              </span>
            </>
          );
        },
      },
      {
        title: "日期類型",
        width: "50px",
        align: "center",
        responsive: ["md"],
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                color: record.WorkStatus === "WORK" ? "#483D8B" : "#B22222",
                backgroundColor:
                  record.WorkStatus === "WORK" ? "#FFFFFF" : "#DCDCDC",
              },
            },
            children: (
              <div>
                {record.WorkReason}{" "}
                {record.ClockType === "FLEXIBLE" ? (
                  <Tag color="blue">彈</Tag>
                ) : (
                  ""
                )}
                {record.ClockType === "OVERTIME" ? (
                  <Tag color="red">加</Tag>
                ) : (
                  ""
                )}
              </div>
            ),
          };
        },
      },
      {
        title: "作息標準",
        width: "30px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { WorkStatus, ClockOutTimeMust, ClockInTimeMust } = item;
          return (
            <>
              {WorkStatus === "WORK" ? (
                <span
                  style={{ color: "green", fontWeight: 500, fontSize: "0.9em" }}
                >
                  {ClockInTimeMust}-{ClockOutTimeMust}
                </span>
              ) : (
                ""
              )}
            </>
          );
        },
      },
      {
        title: "簽到退時間",
        width: "100px",
        align: "center",
        render: (item) => {
          const {
            BunchTimeFirst,
            BunchTimeLast,
            BackFillStatusFirst,
            BackFillStatusLast,
          } = item;
          return (
            <span style={{ fontWeight: 900, fontSize: "1.2em" }}>
              {BunchTimeFirst != null ? (
                <>
                  {formateHHMMDate(BunchTimeFirst)}
                  {BackFillStatusFirst === "NONE" ? (
                    ""
                  ) : (
                    <Tag color="volcano" style={{ marginLeft: "5px" }}>
                      補
                    </Tag>
                  )}
                </>
              ) : (
                ""
              )}
              {BunchTimeLast != null ? (
                <>
                  <>-</>
                  {formateHHMMDate(BunchTimeLast)}
                  {BackFillStatusLast === "NONE" ? (
                    ""
                  ) : (
                    <Tag color="volcano" style={{ marginLeft: "5px" }}>
                      補
                    </Tag>
                  )}
                </>
              ) : (
                ""
              )}
            </span>
          );
        },
      },
      {
        title: "身分別",
        width: "50px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { Insurance } = item;
          return (
            <>
              <Tag color={Insurance === "公保" ? "purple" : "orange"}>
                {Insurance}
              </Tag>
            </>
          );
        },
      },
      {
        title: "職號",
        width: "40px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { StaffCode } = item;
          return <span style={{ fontWeight: 900 }}>{StaffCode}</span>;
        },
      },
      {
        title: "姓名",
        width: "40px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { StaffName } = item;
          return <span style={{ fontWeight: 900 }}>{StaffName}</span>;
        },
      },
      {
        title: "部門",
        width: "90px",
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { UnitName } = item;
          return (
            <span style={{ fontWeight: 900, fontSize: "0.8em" }}>
              {UnitName}
            </span>
          );
        },
      },

      {
        title: "備註",
        width: 50,
        render: (item) => {
          const { takeLeaveType, takeLeaveTimeHours } = item;
          return (
            <span>
              {takeLeaveType != null ? takeLeaveType : ""}
              {takeLeaveType != null ? this.formatTime(takeLeaveTimeHours) : ""}
            </span>
          );
        },
      },
    ];
  };

  formatTime = (timeString) => {
    // 将字符串按逗号分割并转换为数字
    const [daysStr, hoursStr] = timeString.split(",");
    const days = parseInt(daysStr, 10);
    const hours = parseInt(hoursStr, 10);

    let result = [];

    if (days > 0) {
      result.push(`${days}天`);
    }
    if (hours > 0) {
      result.push(`${hours}小時`);
    }

    return result.join("");
  };

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { nowYearMonth, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true });
    const result = await req_list_pim_staff(
      userLevel,
      userCode,
      nowYearMonth,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      //console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_downloadfile_items = async () => {
    const { nowYearMonth, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    // download file data
    const fileUrl = await req_downloadfile_pim_staff(
      userCode,
      userLevel,
      nowYearMonth,
      searchField,
      searchValue,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  handle_data_refresh = () => {
    this.api_item_list();
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_downloadfile_items();

        break;
      default:
    }
  };

  render() {
    const { data, loading, nowYearMonth, searchField, searchValue } =
      this.state;
    const title = (
      <>
        <Input
          placeholder="年月"
          style={{ width: 100, margin: "0 5px" }}
          value={nowYearMonth}
          onChange={(event) =>
            this.setState({ nowYearMonth: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">請選擇</Select.Option>
          <Select.Option value="ClockDate">簽到退日期</Select.Option>
          <Select.Option value="StaffCode">職號</Select.Option>
          <Select.Option value="StaffName">姓名</Select.Option>
          <Select.Option value="UnitName">部門名稱</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}

        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "2px", marginBottom: "6px" }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </Button>
      </>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(ClockLogStaff);
